import script from "./copy-receipts-button.vue?vue&type=script&lang=js"
export * from "./copy-receipts-button.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__